const manomano = (typeof window !== 'undefined' && window.manomano) || {};

export const getDataLayer = () =>
  typeof window !== 'undefined' && window.dataLayer;
export const isNewUser = () =>
  manomano.isNewUser && typeof manomano.isNewUser === 'function'
    ? manomano.isNewUser()
    : false;
